
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("d3OVq", function(module, exports) {
/**
 * @generated SignedSource<<78fc3cf09192ba1ef2849e479aa1249e>>
 * @relayHash 08655b5a07a80d6db6123fa2b954538c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a03e95f43b1257f84130aca2fcbdeff6cdf7b832e117cacf3d0b825870beb22
const $49f91628ee52d08c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "width"
    }, v5 = {
        "kind": "ScalarField",
        "name": "height"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "concreteType": "MapOfStringToString",
        "kind": "LinkedField",
        "name": "hoverOrFocus",
        "plural": true,
        "selections": v6 /*: any*/ 
    }, v8 = {
        "kind": "ScalarField",
        "name": "color"
    }, v9 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v10 = [
        v9 /*: any*/ ,
        v8 /*: any*/ 
    ], v11 = [
        v8 /*: any*/ ,
        v7 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "background"
    }, v13 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v14 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v15 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v16 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v18 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v19 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v20 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v21 = [
        v12 /*: any*/ ,
        v9 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "padding"
        },
        {
            "kind": "ScalarField",
            "name": "borderRadius"
        }
    ], v22 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                },
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isDefault"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "SpaceSettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "routeOverrideEnabled"
                                }
                            ]
                        },
                        {
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "theme",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "themeKey"
                                }
                            ]
                        },
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "headings",
                                    "plural": true,
                                    "selections": v6 /*: any*/ 
                                },
                                {
                                    "concreteType": "MenusLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "menus",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "HeaderLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "header",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "ButtonLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "button",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "NavigationLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "primaryNavigation",
                                            "plural": false,
                                            "selections": v11 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "NavigationLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "secondaryNavigation",
                                            "plural": false,
                                            "selections": v11 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "SearchFieldLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "search",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ScreenLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "screen",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                {
                                                    "concreteType": "LayerScreenLookAndFeel",
                                                    "kind": "LinkedField",
                                                    "name": "layer",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterTop"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterRight"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterBottom"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterLeft"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "container",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "header",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "body",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "SpaceMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "prefix"
                                                },
                                                v3 /*: any*/ ,
                                                v1 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceBaseQueryBaseQuery",
            "selections": v22 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceBaseQueryBaseQuery",
            "selections": v22 /*: any*/ 
        },
        "params": {
            "cacheID": "08655b5a07a80d6db6123fa2b954538c",
            "id": "6a03e95f43b1257f84130aca2fcbdeff6cdf7b832e117cacf3d0b825870beb22",
            "metadata": {},
            "name": "useSpaceBaseQueryBaseQuery",
            "operationKind": "query",
            "text": "query useSpaceBaseQueryBaseQuery($spaceKey:String){spaces(spaceKey:$spaceKey){nodes{id,key,alias,name,homepage{id},icon{path,width,height,isDefault},type,settings{routeOverrideEnabled},theme{themeKey},lookAndFeel{headings{key,value},menus{hoverOrFocus{key,value},color},header{backgroundColor,button{backgroundColor,color},primaryNavigation{color,hoverOrFocus{key,value}},secondaryNavigation{color,hoverOrFocus{key,value}},search{backgroundColor,color}},content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius},header{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius},body{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},metadata{labels{nodes{prefix,name,id}}},operations{operation,targetType}}}}"
        }
    };
}();
$49f91628ee52d08c$var$node.hash = "e885d5c349d4cf19afe686a9f6747925";
var $49f91628ee52d08c$export$2e2bcd8739ae039 = $49f91628ee52d08c$var$node;
module.exports["default"] = $49f91628ee52d08c$export$2e2bcd8739ae039;

});

parcelRegister("fM6x5", function(module, exports) {
$parcel$export(module.exports, "default", () => $6436abe84fc91b7d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $8EsbU = parcelRequire("8EsbU");


var $d5RCH = parcelRequire("d5RCH");

function $6436abe84fc91b7d$export$2e2bcd8739ae039(getTitle, wrapperStyle) {
    if (typeof wrapperStyle === 'undefined') wrapperStyle = {};
    return (BaseComponent)=>(props)=>{
            const title = getTitle(props);
            const siteTitle = (0, $8EsbU.getOverride)('site-title') || '';
            const titleDefinedOnWindow = window['__DOCUMENT_TITLE_TAG__'] || '';
            let titleProp;
            if (titleDefinedOnWindow) titleProp = titleDefinedOnWindow;
            else if (title && siteTitle) titleProp = `${title} - ${siteTitle}`;
            else titleProp = title || siteTitle;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                style: wrapperStyle,
                "data-testid": "with-document-title"
            }, !window['__SSR_RENDERED__'] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
                title: titleProp
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, props)));
        };
}

});

parcelRegister("iqPBi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $2daQU = parcelRequire("2daQU");


var $inPa6 = parcelRequire("inPa6");



var $dPJCf = parcelRequire("dPJCf");


var $1ytiN = parcelRequire("1ytiN");


var $fM6x5 = parcelRequire("fM6x5");


var $cEgMD = parcelRequire("cEgMD");


var $8oCjN = parcelRequire("8oCjN");


var $4b4iP = parcelRequire("4b4iP");


var $j9XVO = parcelRequire("j9XVO");

const $023f02fd9a9aead0$var$DISPLAY_ROOT = 'display';
const $023f02fd9a9aead0$var$SPACE_ROOT = 'spaces';
const $023f02fd9a9aead0$var$getUrlRoot = (pathname)=>{
    if (!pathname) return undefined;
    if (pathname.includes(`/${$023f02fd9a9aead0$var$SPACE_ROOT}/`)) return $023f02fd9a9aead0$var$SPACE_ROOT;
    else if (pathname.includes(`/${$023f02fd9a9aead0$var$DISPLAY_ROOT}/`)) return $023f02fd9a9aead0$var$DISPLAY_ROOT;
    else return undefined;
};
const $023f02fd9a9aead0$var$useContentSlug = (0, $dPJCf.createRouteParamHook)('contentSlug');
const $023f02fd9a9aead0$var$useContentId = (0, $dPJCf.createRouteParamHook)('contentId');
const $023f02fd9a9aead0$var$LegacySpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAnonymous: isAnonymous } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const history = (0, $dPJCf.useHistory)();
    const isFirstRoute = history?.length === 1;
    const location = (0, $QU6QS.useLocation)();
    const fixSpaceEncodingInSpaceKey = ()=>{
        const pathname = location?.pathname || '';
        const decodedPathname = decodeURIComponent(pathname);
        if (// excludes the cases where there are no + symbols to replace at all
        // eg: /spaces/perfectly-fine-space-key
        pathname.indexOf('+') !== -1 && // excludes the cases where there is a + that follows the space key portion of the path
        // eg: /spaces/DS/other+stuff+that+contains+plus
        spaceKey.indexOf('+') !== -1 && // excludes the cases where the decoded path name still contains a + (from %2B)
        // , but the replacement to strip the + from the space key has already happened in previous SPA transition
        // eg: pathname = '/spaces/space%2Bkey', decodedPathname = '/spaces/space+key', spaceKey = 'space+key'
        decodedPathname.indexOf(`spaces/${spaceKey}`) !== -1) history?.replace?.({
            ...location,
            // Ensure we are replacing the "+" in the space key not other funny stuff
            pathname: decodedPathname.replace(`spaces/${spaceKey}`, `spaces/${spaceKey}`.replace(/\+/g, ' '))
        });
    };
    const removeEmailQueryParameters = ()=>{
        if (!location?.search?.includes('src=mail') && !location?.search?.includes('src.mail.')) return;
        let search = location?.search?.substring(1);
        const params = search.split('&').filter((param)=>!param.includes('src=mail') && !param.startsWith('src.mail.'));
        search = `?${params.join('&')}`;
        history?.replace?.({
            ...location,
            search: search
        });
    };
    (0, $42omo.useEffect)(()=>{
        fixSpaceEncodingInSpaceKey();
        removeEmailQueryParameters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isSpaceLoading) return;
        if (space && space.alias && space.alias !== spaceKey) {
            const pathnameRoot = $023f02fd9a9aead0$var$getUrlRoot(location?.pathname);
            if (pathnameRoot) {
                const routeName = routeDataRef.current?.routeName || null;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'redirect',
                        actionSubject: 'route',
                        source: 'SpaceBase',
                        attributes: {
                            routeName: routeName,
                            // Space key related attributes.
                            areSpaceKeysEqualLowercase: space?.alias?.toLowerCase() === spaceKey?.toLowerCase()
                        }
                    }
                }).fire();
                history?.replace?.({
                    ...location,
                    pathname: location?.pathname?.replace(`/${pathnameRoot}/${spaceKey}`, `/${pathnameRoot}/${space.alias}`)
                });
            }
            return;
        }
    }, [
        createAnalyticsEvent,
        history,
        location,
        space,
        spaceKey,
        routeDataRef,
        isSpaceLoading
    ]);
    /*
   * Removing SpaceBaseThemedComponent for the Company Hub app-like experience
   *
   * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
   * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
   */ const SpaceBaseWrapper = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) ? (0, $42omo.Fragment) : (0, $8oCjN.SpaceBaseThemedComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        isAnonymous: isAnonymous,
        contentId: contentId,
        isFirstRoute: isFirstRoute,
        goBackPreviousPage: history?.goBack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpaceBaseWrapper, null, children)));
};
const $023f02fd9a9aead0$var$SpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const { isAnonymous: isAnonymous } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    return $023f02fd9a9aead0$var$LegacySpaceBaseComponent({
        children: children,
        spaceKey: spaceKey,
        space: space,
        isSpaceLoading: isSpaceLoading
    });
};
const $023f02fd9a9aead0$var$useSpaceKey = (0, $dPJCf.createRouteParamHook)('spaceKey');
const $023f02fd9a9aead0$export$adbf61121b32bd9b = ({ children: children, spaceKey: spaceKey })=>{
    const resolvedSpaceKey = $023f02fd9a9aead0$var$useSpaceKey() || spaceKey || '';
    const { space: space, loading: loading } = (0, $j9XVO.useSpaceBaseQuery)({
        resolvedSpaceKey: resolvedSpaceKey
    });
    return (0, $fM6x5.default)(()=>space?.name)($023f02fd9a9aead0$var$SpaceBaseComponent)({
        spaceKey: resolvedSpaceKey,
        space: space,
        children: children,
        isSpaceLoading: loading
    });
};
module.exports["SpaceBase"] = $023f02fd9a9aead0$export$adbf61121b32bd9b;

});

parcelRegister("8oCjN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $lKNXy = parcelRequire("lKNXy");


var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $3Klda = parcelRequire("3Klda");


var $5ZqQS = parcelRequire("5ZqQS");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $fyPYm = parcelRequire("fyPYm");


var $eSlm6 = parcelRequire("eSlm6");

const $7bbee5da9ba28ec8$var$connectAddonContainerStyle = {
    position: 'relative'
};
const $7bbee5da9ba28ec8$var$connectAddonProps = {
    contentStyle: {
        width: '100%',
        textAlign: 'center',
        display: 'inline-block'
    },
    width: '100%',
    height: '100%'
};
const $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX = /^ac:(.*)__(.*)-remote-theme$/;
const $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7 = (themeKey)=>{
    const regexResult = $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX.exec(themeKey);
    return regexResult ? [
        regexResult[1],
        regexResult[2]
    ] : [
        null,
        null
    ];
};
const $7bbee5da9ba28ec8$export$7f576b861c4a75d4 = ({ children: children })=>{
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [{ contentIdLoading: contentIdLoading }] = (0, $ep3mz.usePageState)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $lpxTx.ContentBlogUnifiedQuery) : (0, $61vTv.ContentUnifiedQuery);
    const isSpaceOverview = match?.name === (0, $1NBp8.SPACE_OVERVIEW).name;
    const skipContentQuery = !contentId || !spaceKey || !isSpaceOverview || contentIdLoading;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const contentQueryResult = (0, $diswb.useQuery)(chooseContentUnifiedQuery, {
        context: {
            single: true
        },
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: null,
            useNewContentTopper: true
        },
        skip: skipContentQuery
    });
    const themeKey = contentQueryResult?.data?.space?.theme?.themeKey;
    const routeOverrideEnabled = contentQueryResult?.data?.space?.settings?.routeOverrideEnabled;
    const [themeAddonKey, themeModuleKey] = $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7(themeKey);
    const skipOverrideQuery = !themeAddonKey || !themeModuleKey || !routeOverrideEnabled;
    const overrideQueryResult = (0, $eSlm6.useExperimentalThemeSpaceHomeOverrideQuery)({
        variables: {
            themeAddonKey: themeAddonKey,
            themeModuleKey: themeModuleKey,
            spaceKey: spaceKey || '',
            spaceHomePageId: contentId || ''
        },
        skip: skipOverrideQuery
    });
    if (contentQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(contentQueryResult.error, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(contentQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    }
    if (overrideQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(overrideQueryResult.error, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(overrideQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    }
    if (contentIdLoading) return null;
    if (skipContentQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    if (contentQueryResult.loading || !skipOverrideQuery && overrideQueryResult.loading) return null;
    if (skipOverrideQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    if (!contentQueryResult.data || !overrideQueryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    const { hasSpaceHomeOverride: hasSpaceHomeOverride, spaceHomeOverrideDescriptor: spaceHomeOverrideDescriptor } = overrideQueryResult.data.experimentalThemeSpaceHomeOverride;
    if (!hasSpaceHomeOverride || !spaceHomeOverrideDescriptor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    // Ensure required fields are present for ConnectAddonDescriptor
    if (!spaceHomeOverrideDescriptor.addon_key || !spaceHomeOverrideDescriptor.key || !spaceHomeOverrideDescriptor.url || !spaceHomeOverrideDescriptor.contextJwt || !spaceHomeOverrideDescriptor.structuredContext || !spaceHomeOverrideDescriptor.productCtx) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    const descriptor = {
        addon_key: spaceHomeOverrideDescriptor.addon_key,
        key: spaceHomeOverrideDescriptor.key,
        url: spaceHomeOverrideDescriptor.url,
        contextJwt: spaceHomeOverrideDescriptor.contextJwt,
        structuredContext: spaceHomeOverrideDescriptor.structuredContext,
        productContext: JSON.parse(spaceHomeOverrideDescriptor.productCtx)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
        lookAndFeel: contentQueryResult?.data?.space?.lookAndFeel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lKNXy.ConnectAddon), {
        containerStyle: $7bbee5da9ba28ec8$var$connectAddonContainerStyle,
        descriptor: descriptor,
        ...$7bbee5da9ba28ec8$var$connectAddonProps
    }), isSpaceOverview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fyPYm.ContentViewedEvent), {
        contentId: contentId
    }));
};
module.exports["SpaceBaseThemedComponent"] = $7bbee5da9ba28ec8$export$7f576b861c4a75d4;

});

parcelRegister("eSlm6", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $d5f5bff41df6d94f$export$aa603d43549e91b7 = ({ skip: skip, variables: variables })=>{
    const { themeAddonKey: themeAddonKey, themeModuleKey: themeModuleKey, spaceKey: spaceKey, spaceHomePageId: spaceHomePageId } = variables;
    return (0, $dK51B.useExperimentalQuery)({
        url: ()=>{
            if (!themeAddonKey || !themeModuleKey) // This will be handled by parseResponseOnError to return expected data when these keys are missing
            throw new Error('themeAddonKey and themeModuleKey are missing');
            return `/wiki/plugins/servlet/ac/${themeAddonKey}/${themeModuleKey}/?classifier=json&space.key=${spaceKey}&content.id=${spaceHomePageId}&content.type=page`;
        },
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnError: ()=>null,
        parseResult: (data)=>({
                experimentalThemeSpaceHomeOverride: {
                    hasSpaceHomeOverride: data !== null,
                    spaceHomeOverrideDescriptor: data
                }
            }),
        skip: skip,
        variables: variables
    });
};
module.exports["useExperimentalThemeSpaceHomeOverrideQuery"] = $d5f5bff41df6d94f$export$aa603d43549e91b7;

});

parcelRegister("4b4iP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $67Foi = parcelRequire("67Foi");


var $eAduJ = parcelRequire("eAduJ");


var $fG32j = parcelRequire("fG32j");


var $aZfd8 = parcelRequire("aZfd8");

const $343989ced147f5e6$export$20a459334853e190 = ({ children: children, spaceKey: spaceKey, isAnonymous: isAnonymous = false, contentId: contentId, isFirstRoute: isFirstRoute = false, goBackPreviousPage: goBackPreviousPage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fG32j.SpaceRestrictionCheck), {
        spaceKey: spaceKey
    }, ({ isSpaceRestricted: isSpaceRestricted, isSpaceNotFound: isSpaceNotFound })=>{
        if (isSpaceRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eAduJ.RestrictedSpace), {
            goToPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute,
            contentId: contentId
        });
        if (isSpaceNotFound && !isAnonymous && !contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZfd8.Space404), {
            goBackPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
            name: "spaceNotFoundScreen",
            id: spaceKey
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    });
};
module.exports["SpaceRestrictionHandler"] = $343989ced147f5e6$export$20a459334853e190;

});

parcelRegister("aZfd8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $wtSEP = parcelRequire("wtSEP");

const $c70a78199cd90f84$export$a506b89ee82dfeb8 = (props)=>{
    const { isFirstRoute: isFirstRoute, goBackPreviousPage: goBackPreviousPage } = props;
    const onClickGoPreviousLink = (e)=>{
        e.preventDefault();
        if (goBackPreviousPage) goBackPreviousPage();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), {
        secondaryButtonProps: {
            children: !isFirstRoute && goBackPreviousPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "space-404.text.go.back.previous.page",
                defaultMessage: "Go to previous page"
            }),
            onClick: onClickGoPreviousLink
        }
    });
};
$c70a78199cd90f84$export$a506b89ee82dfeb8.displayName = 'Space404';
module.exports["Space404"] = $c70a78199cd90f84$export$a506b89ee82dfeb8;

});

parcelRegister("j9XVO", function(module, exports) {

var $kiJuS = parcelRequire("kiJuS");


var $d3OVq = parcelRequire("d3OVq");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");

const $2278a3c3763ebfe6$export$f1cfc3b574a4d714 = (0, $d3OVq.default);
const $2278a3c3763ebfe6$export$9d574d064e4f4f51 = (0, $kiJuS.default);
const $2278a3c3763ebfe6$export$8eab19bcc4a0311d = ({ resolvedSpaceKey: resolvedSpaceKey })=>{
    const { data: spaceBaseQueryData, loading: spaceBaseQueryLoading, error: spaceBaseQueryError } = (0, $jMyy4.useQueryInterop)($2278a3c3763ebfe6$export$f1cfc3b574a4d714, {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        }
    });
    const { data: singleSpaceQueryData, loading: singleSpaceQueryLoading, error: singleSpaceQueryError } = (0, $jMyy4.useQueryInterop)($2278a3c3763ebfe6$export$9d574d064e4f4f51, {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || !(0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        }
    });
    let space, loading;
    if ((0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
        loading = singleSpaceQueryLoading;
        space = singleSpaceQueryError && !singleSpaceQueryLoading ? null : singleSpaceQueryData?.space;
    } else {
        loading = spaceBaseQueryLoading;
        space = spaceBaseQueryError && !spaceBaseQueryLoading ? null : spaceBaseQueryData?.spaces?.nodes?.[0];
    }
    return {
        space: space,
        loading: loading
    };
};
module.exports["useSpaceBaseQuery"] = $2278a3c3763ebfe6$export$8eab19bcc4a0311d;

});

parcelRegister("kiJuS", function(module, exports) {
/**
 * @generated SignedSource<<198a17bc152886227706d3564183c442>>
 * @relayHash c65404aa4339865deb33b960b63ac1fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e03d29f1801373ff6e80b3bfcf7c8bfe26a96bb6370f9f8c083d9d51a7a1a366
const $667a49a7f0668b30$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c65404aa4339865deb33b960b63ac1fb",
            "id": "e03d29f1801373ff6e80b3bfcf7c8bfe26a96bb6370f9f8c083d9d51a7a1a366",
            "metadata": {},
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "operationKind": "query",
            "text": "query useSpaceBaseQuerySingleSpaceQuery($spaceKey:String){space(key:$spaceKey){id,key,name,alias}}"
        }
    };
}();
$667a49a7f0668b30$var$node.hash = "0994a40a61365970e08e840dbdb433df";
var $667a49a7f0668b30$export$2e2bcd8739ae039 = $667a49a7f0668b30$var$node;
module.exports["default"] = $667a49a7f0668b30$export$2e2bcd8739ae039;

});

parcelRegister("crTA1", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("iqZzD")).default);

var $iqZzD = parcelRequire("iqZzD");


});

parcelRegister("iqZzD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6ba6afbc5717c4a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $iqPBi = parcelRequire("iqPBi");

var $d6ba6afbc5717c4a$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPBi.SpaceBase), props);
};

});

parcelRegister("4H46k", function(module, exports) {
// These exports are using the .default prop of the module because we're mixing ES6 and ES5. This is required for
// webpack to be able to correctly split bundles.

var $jmjWc = parcelRequire("jmjWc");


const $36ae5bfcf92491af$export$2f32c75fff716fcc = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b7m6n",
    name: "LazySpaceBlogRedirect",
    loader: async ()=>(await (parcelRequire("c29Ia"))).SpaceBlogRedirect
});

const $36ae5bfcf92491af$export$5590c410e7d0a293 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LfHUf",
    name: "LazySpaceCreatePage",
    loader: ()=>(parcelRequire("6n6J1"))
});

const $36ae5bfcf92491af$export$e650af616d3a92cf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Z1eTA",
    name: "LazyMobileWebContainer",
    loader: ()=>(parcelRequire("eDai7"))
});

const $36ae5bfcf92491af$export$dcf40c4d983a3b1f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TnNDX",
    name: "LazyDwellTime",
    loader: ()=>(parcelRequire("djVjJ"))
});

const $36ae5bfcf92491af$export$a804be9097757ef8 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "GCYkT",
    name: "LazyConsumptionViewedAndCompletedEventTracker",
    loader: async ()=>(await (parcelRequire("ipPBg"))).ConsumptionViewedAndCompletedEventTracker
});

const $36ae5bfcf92491af$export$33256e23669f7955 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AaHry",
    name: "LazyConfluenceNotFound",
    loader: ()=>(parcelRequire("eQZPX"))
});
module.exports["LazySpaceBlogRedirect"] = $36ae5bfcf92491af$export$2f32c75fff716fcc;
module.exports["LazySpaceCreatePage"] = $36ae5bfcf92491af$export$5590c410e7d0a293;
module.exports["LazyMobileWebContainer"] = $36ae5bfcf92491af$export$e650af616d3a92cf;
module.exports["LazyDwellTime"] = $36ae5bfcf92491af$export$dcf40c4d983a3b1f;
module.exports["LazyConsumptionViewedAndCompletedEventTracker"] = $36ae5bfcf92491af$export$a804be9097757ef8;
module.exports["LazyConfluenceNotFound"] = $36ae5bfcf92491af$export$33256e23669f7955;

});

parcelRegister("c29Ia", function(module, exports) {

let $8c2d346fe517694f$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("kzRPH"), 5)),
    $8c2d346fe517694f$var$load("gaXhw")
]).then(()=>parcelRequire('4bW1i'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("alui6", function(module, exports) {
"use strict";

var $h4lNe = parcelRequire("h4lNe");

module.exports = $h4lNe(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});

parcelRegister("h4lNe", function(module, exports) {
"use strict";
let $c6d3b70899d3a8aa$var$cachedBundles = {};
let $c6d3b70899d3a8aa$var$cachedPreloads = {};
let $c6d3b70899d3a8aa$var$cachedPrefetches = {};
function $c6d3b70899d3a8aa$var$getCache(type) {
    switch(type){
        case 'preload':
            return $c6d3b70899d3a8aa$var$cachedPreloads;
        case 'prefetch':
            return $c6d3b70899d3a8aa$var$cachedPrefetches;
        default:
            return $c6d3b70899d3a8aa$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $c6d3b70899d3a8aa$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});

parcelRegister("6n6J1", function(module, exports) {

let $4a3a1b8a365b5f3e$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $4a3a1b8a365b5f3e$var$load("aLLXO"),
    $4a3a1b8a365b5f3e$var$load("2YffH"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("meCbt"), 5)),
    $4a3a1b8a365b5f3e$var$load("7deCi"),
    $4a3a1b8a365b5f3e$var$load("2SjHp"),
    $4a3a1b8a365b5f3e$var$load("2PePB"),
    $4a3a1b8a365b5f3e$var$load("aT7sf"),
    $4a3a1b8a365b5f3e$var$load("fRvqe"),
    $4a3a1b8a365b5f3e$var$load("2F69B"),
    $4a3a1b8a365b5f3e$var$load("89WyM"),
    $4a3a1b8a365b5f3e$var$load("ev7SX"),
    $4a3a1b8a365b5f3e$var$load("fJtJG"),
    $4a3a1b8a365b5f3e$var$load("glHWp"),
    $4a3a1b8a365b5f3e$var$load("9w0Re"),
    $4a3a1b8a365b5f3e$var$load("1wQU1"),
    $4a3a1b8a365b5f3e$var$load("lkOIY"),
    $4a3a1b8a365b5f3e$var$load("clQc9"),
    $4a3a1b8a365b5f3e$var$load("8PPsf"),
    $4a3a1b8a365b5f3e$var$load("cyGuT"),
    $4a3a1b8a365b5f3e$var$load("jbxHq"),
    $4a3a1b8a365b5f3e$var$load("7f9Fz"),
    $4a3a1b8a365b5f3e$var$load("lYvov"),
    $4a3a1b8a365b5f3e$var$load("k8XPW"),
    $4a3a1b8a365b5f3e$var$load("fWCRm"),
    $4a3a1b8a365b5f3e$var$load("ht6hk"),
    $4a3a1b8a365b5f3e$var$load("9ijrN"),
    $4a3a1b8a365b5f3e$var$load("aeEUI"),
    $4a3a1b8a365b5f3e$var$load("eY3St"),
    $4a3a1b8a365b5f3e$var$load("bkd4T"),
    $4a3a1b8a365b5f3e$var$load("Wowvf"),
    $4a3a1b8a365b5f3e$var$load("7EorR"),
    $4a3a1b8a365b5f3e$var$load("awqCy"),
    $4a3a1b8a365b5f3e$var$load("6wr18"),
    $4a3a1b8a365b5f3e$var$load("kjZZD"),
    $4a3a1b8a365b5f3e$var$load("3ySTn"),
    $4a3a1b8a365b5f3e$var$load("c2rHL"),
    $4a3a1b8a365b5f3e$var$load("hhss7"),
    $4a3a1b8a365b5f3e$var$load("kvhKJ"),
    $4a3a1b8a365b5f3e$var$load("k5VqV"),
    $4a3a1b8a365b5f3e$var$load("8m8aj"),
    $4a3a1b8a365b5f3e$var$load("lT67w"),
    $4a3a1b8a365b5f3e$var$load("fZt2F"),
    $4a3a1b8a365b5f3e$var$load("flGQy"),
    $4a3a1b8a365b5f3e$var$load("lY1AS"),
    $4a3a1b8a365b5f3e$var$load("ffEVr"),
    $4a3a1b8a365b5f3e$var$load("7q8Na"),
    $4a3a1b8a365b5f3e$var$load("kAAjo"),
    $4a3a1b8a365b5f3e$var$load("fbRdC"),
    $4a3a1b8a365b5f3e$var$load("gZGoR"),
    $4a3a1b8a365b5f3e$var$load("iqKwT"),
    $4a3a1b8a365b5f3e$var$load("efnul"),
    $4a3a1b8a365b5f3e$var$load("9IeAj"),
    $4a3a1b8a365b5f3e$var$load("18EHe"),
    $4a3a1b8a365b5f3e$var$load("kT5Gk"),
    $4a3a1b8a365b5f3e$var$load("6rxNA"),
    $4a3a1b8a365b5f3e$var$load("ivVUT"),
    $4a3a1b8a365b5f3e$var$load("2K40s"),
    $4a3a1b8a365b5f3e$var$load("1dcav"),
    $4a3a1b8a365b5f3e$var$load("8ublV"),
    $4a3a1b8a365b5f3e$var$load("4yA1q"),
    $4a3a1b8a365b5f3e$var$load("5vIUN"),
    $4a3a1b8a365b5f3e$var$load("kHDuB"),
    $4a3a1b8a365b5f3e$var$load("6UKHF")
]).then(()=>parcelRequire('lJvEZ'));

});

parcelRegister("eDai7", function(module, exports) {

let $aa6cb0d62c460e24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa6cb0d62c460e24$var$load("2F69B"),
    $aa6cb0d62c460e24$var$load("kOWvR"),
    $aa6cb0d62c460e24$var$load("2K40s"),
    $aa6cb0d62c460e24$var$load("1dcav"),
    $aa6cb0d62c460e24$var$load("4D7T2")
]).then(()=>parcelRequire('1x5LM'));

});

parcelRegister("djVjJ", function(module, exports) {

let $9b2982b618f8cf76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9b2982b618f8cf76$var$load("9HjYv").then(()=>parcelRequire('7SYCP'));

});

parcelRegister("ipPBg", function(module, exports) {

let $d682967ebe3fde01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d682967ebe3fde01$var$load("f2uDI").then(()=>parcelRequire('3deqg'));

});

parcelRegister("eQZPX", function(module, exports) {

let $ad05e39509ec3e59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ad05e39509ec3e59$var$load("kOWvR").then(()=>parcelRequire('4uiGD'));

});


//# sourceMappingURL=EditPageContainer.82745f64.js.map
